// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"9aed863f","577":"9a4cc1fc","778":"3cbe4165","961":"f64b1195"}[chunkId] + ".chunk.js";
};